import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

// Silent token acquisition (acquireTokenSilent) redeems the refresh token via a
// cross-origin POST to Azure AD, which validates redirect_uri against the app's
// registered SPA redirect URIs. We use window.location.origin here because it is
// guaranteed registered (interactive login succeeds through it). Using an
// unregistered URI such as /blank.html causes Azure to reject the redemption
// with a 400 (AADSTS9002326), breaking API token acquisition.
export const silentRedirectUri = window.location.origin;

/**
 * Clear stuck MSAL interaction-status flags from storage without touching
 * cached tokens or auth responses. Call this before any loginRedirect to
 * prevent "interaction_in_progress" errors blocking future auth flows.
 */
export function clearInteractionState(): void {
  for (const storage of [sessionStorage, localStorage]) {
    try {
      for (const key of Object.keys(storage)) {
        if (
          key.includes('interaction.status') ||
          key.includes('interaction_in_progress') ||
          key.includes('msal.interaction.status')
        ) {
          storage.removeItem(key);
        }
      }
    } catch {
      // storage access blocked — ignore
    }
  }
}
